import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddOldCarFlow.css";
import LoaderCon from "../../Common/loader/containers/loader_cont";
import Snackbar1 from "../../Common/snackbar/components/snackbar";
import { useDispatch } from "react-redux";
import { close_snack_bar } from "../../Common/snackbar/action";
import StepIndicator from "./Common/StepIndicator";
import { Shield, Zap, Wind, Music, Eye, Layout, Settings, CheckSquare } from "lucide-react";

export default function Feature(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // ---------------- STATE ----------------
  const [form, setForm] = useState({
    airbag: "",
    tyrePresssure: false,
    childSeatAnchorPoints: false,
    seatBeltWarning: false,
    abs: false,
    ebd: false,
    ba: false,
    esp: false,
    fourWheel: false,
    hillHoldControl: false,
    tcs: false,
    hillDescentControl: false,
    engineImmobiliser: false,
    centeralLocking: false,
    speedSensingDoorLock: false,
    childSafetyLock: false,
    ac: false,
    frontac: false,
    rearac: false,
    heater: false,
    vanityMirror: false,
    antiglareMirror: false,
    parkingAssist: false,
    parkingSensor: false,
    cruisecontrol: false,
    headlightIgnition: false,
    keylessstart: false,
    steeringAdjustment: false,
    power: false,
    applecarplay: false,
    androidauto: false,
    seatUpholestry: false,
    drivesideAdjust: false,
    leatherWrapped: false,
    driverArmrest: false,
    foldingRearSeat: false,
    splitRearSeat: false,
    splitThirdRowSeat: false,
    frontSeatbackPockets: false,
    headrests: false,
    cupholders: false,
    driverArmrestStorage: false,
    cooledGloveBox: false,
    sunGlassHolder: false,
    thirdRowCupHolder: false,
    orvm: false,
    powerWindow: false,
    oneTouchDown: false,
    oneTouchUp: false,
    adjustableOrvm: false,
    exteriorDoorHandle: false,
    chromeexteriorDoorHandle: false,
    doorPockets: false,
    bootlidOpener: false,
    sunroof: false,
    roofMountedAntenna: false,
    bodyColouredBumpers: false,
    chromeFinish: false,
    projectorheadlight: false,
    autoheadlamps: false,
    homeheadlamps: false,
    drl: false,
    tailights: false,
    cabinLamps: false,
    lightonVanityMirror: false,
    rearreadinglamp: false,
    gloveBoxlamp: false,
    headlightHeightAdjuster: false,
    tripMeter: false,
    averageFuelConsumption: false,
    distancetoEmpty: false,
    clock: false,
    lowFuelWarning: false,
    doorAjarWarning: false,
    adjustableCluster: false,
    gearIndicator: false,
    shiftIndicator: false,
    tachometer: false,
    musicSystem: false,
    speaker: false,
    steeringmountedctrls: false,
    voiceCommand: false,
    gps: false,
    bluetooth: false,
    aux: false,
    radio: false,
    usb: false,
    headUnitSize: false,
    des12: "",
  });

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const sections = [
    {
      title: "Safety",
      icon: <Shield size={20} />,
      items: [
        ["tyrePresssure", "TPMS"],
        ["childSeatAnchorPoints", "Child Seat Anchors"],
        ["seatBeltWarning", "Seat Belt Warning"],
        ["abs", "ABS"],
        ["ebd", "EBD"],
        ["ba", "Brake Assist"],
        ["esp", "ESP"],
      ]
    },
    {
      title: "Locks & Security",
      icon: <Zap size={20} />,
      items: [
        ["engineImmobiliser", "Engine Immobiliser"],
        ["centeralLocking", "Central Locking"],
        ["speedSensingDoorLock", "Speed Sensing Door Lock"],
        ["childSafetyLock", "Child Safety Lock"],
        ["keylessstart", "Keyless / Button Start"],
      ]
    },
    {
      title: "Comfort & Convenience",
      icon: <Wind size={20} />,
      items: [
        ["ac", "Air Conditioner"],
        ["frontac", "Front AC"],
        ["rearac", "Rear AC"],
        ["heater", "Heater"],
        ["cruisecontrol", "Cruise Control"],
        ["parkingSensor", "Parking Sensors"],
        ["parkingAssist", "Parking Assist"],
        ["power", "12V Power Outlets"],
      ]
    },
    {
      title: "Entertainment & Connectivity",
      icon: <Music size={20} />,
      items: [
        ["musicSystem", "Integrated Music System"],
        ["speaker", "Speakers"],
        ["steeringmountedctrls", "Steering Controls"],
        ["applecarplay", "Apple CarPlay"],
        ["androidauto", "Android Auto"],
        ["bluetooth", "Bluetooth"],
        ["gps", "GPS Navigation"],
      ]
    },
    {
      title: "Exterior & Lighting",
      icon: <Eye size={20} />,
      items: [
        ["sunroof", "Sunroof"],
        ["projectorheadlight", "Projector Headlamps"],
        ["drl", "DRL"],
        ["tailights", "LED Taillights"],
        ["autoheadlamps", "Auto Headlamps"],
        ["orvm", "Body Color ORVM"],
      ]
    },
    {
      title: "Interior & Storage",
      icon: <Layout size={20} />,
      items: [
        ["seatUpholestry", "Premium Upholstery"],
        ["leatherWrapped", "Leather Steering"],
        ["driverArmrest", "Driver Armrest"],
        ["cupholders", "Cup Holders"],
        ["cooledGloveBox", "Cooled Glovebox"],
        ["foldingRearSeat", "Folding Rear Seat"],
      ]
    },
    {
      title: "Instrumentation",
      icon: <Settings size={20} />,
      items: [
        ["tripMeter", "Trip Meter"],
        ["distancetoEmpty", "Distance to Empty"],
        ["averageFuelConsumption", "Avg Fuel Economy"],
        ["tachometer", "Tachometer"],
        ["lowFuelWarning", "Low Fuel Warning"],
      ]
    }
  ];

  const handleSubmit = () => {
    const { login, client } = props;
    if (!login?.user_id || !client?.oldCarId) {
      alert("Missing Required ID!");
      return;
    }

    props.addFeature(
      login.token, login.user_id, client.oldCarId,
      ...Object.values(form)
    );
    navigate("/oldcar");
  };

  return (
    <div className="old-car-flow-container">
      <StepIndicator currentStep={4} />

      <div className="old-car-flow-card">
        <h2 className="flow-title">Features & Equipment</h2>
        <p className="flow-subtitle">Select all the features available in this vehicle</p>

        <div className="flow-form">
          <div className="flow-group">
            <label className="flow-label">Airbags</label>
            <select className="flow-select" value={form.airbag} onChange={(e) => handleChange("airbag", e.target.value)}>
              <option value="">Select Airbags</option>
              <option value="No Airbag">No Airbag</option>
              <option value="2 Airbags">2 Airbags</option>
              <option value="4 Airbags">4 Airbags</option>
              <option value="6 Airbags">6 Airbags</option>
            </select>
          </div>

          {sections.map((section, idx) => (
            <div key={idx} className="feature-category">
              <h3 className="category-title">{section.icon} {section.title}</h3>
              <div className="feature-grid">
                {section.items.map(([key, label]) => (
                  <div
                    key={key}
                    className={`feature-checkbox-card ${form[key] ? 'active' : ''}`}
                    onClick={() => handleChange(key, !form[key])}
                  >
                    <div style={{
                      width: '20px',
                      height: '20px',
                      borderRadius: '4px',
                      border: '2px solid',
                      borderColor: form[key] ? 'var(--accent)' : '#cbd5e1',
                      background: form[key] ? 'var(--accent)' : 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      transition: 'all 0.2s'
                    }}>
                      {form[key] && <CheckSquare size={14} color="white" />}
                    </div>
                    <span style={{ fontSize: '14px', fontWeight: '500' }}>{label}</span>
                  </div>
                ))}
              </div>
            </div>
          ))}

          <div className="flow-group full-width">
            <label className="flow-label">Manufacturer Warranty / Additional Notes</label>
            <textarea
              className="flow-textarea"
              placeholder="e.g. 2 years warranty remaining, pristine condition..."
              value={form.des12}
              onChange={(e) => handleChange("des12", e.target.value)}
            />
          </div>

          <div className="flow-actions">
            <button type="button" className="flow-btn-secondary" onClick={() => navigate(-1)}>Back</button>
            <button type="button" className="flow-btn-primary" onClick={handleSubmit}>Finish & Submit</button>
          </div>
        </div>
      </div>

      <LoaderCon />
      <Snackbar1
        open={props.snackbar.response_received}
        close_snack_bar={() => dispatch(close_snack_bar())}
        message={props.snackbar.message}
      />
    </div>
  );
}
